// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Zx2p","question":"styles_question__2jNww","inputVisibleButton":"styles_inputVisibleButton__2Sk-a","note":"styles_note__3Q7DX"};